import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import { Box, Select, MenuItem, Tooltip, Grid, Button, Stack, Tabs, Tab, useTheme } from "@mui/material";

import './projects.scss';
import PanoramaFishEyeOutlinedIcon from '@mui/icons-material/PanoramaFishEyeOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
// import ContentCutIcon from '@mui/icons-material/ContentCut';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

import GridItem from "./GridItem"
import ListItem from "./ListItem"
import { duplicateTemplateProject, getProjects, getWorkspacesList } from './../../../../axios/ApiProvider';
import { copyObject } from "../../../workspaces/dashboard.config";
// import emtpyThumb from '../../../../assets/image/emptyThumb.jpg'
// import NodataImage from "../../../../assets/image/no data.png"
import { NoContent } from "../../../no-content/NoContent";

const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL;
//const BASE_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL;

const BASE_STATIC_STORAGE_URL = process.env.REACT_APP_STATIC_STORAGE_URL;
const EDIT_FRONTEND_URL       = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL;

const VideooEditor_AddTransitions_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Transition%20to%20Video.png'
const VideooEditor_AddMusic_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Subtitle%20to%20Video.png'
const VideooEditor_AddText_Image = BASE_STATIC_STORAGE_URL + '/images/features/Add%20Text%20to%20Video.png'
const VideooEditor_AddStock_Image = BASE_STATIC_STORAGE_URL + '/images/features/Translate%20Video.png'

const VideooEditor_ATV_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/ATV.png'
const VideooEditor_BBC_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/BBC.png'
const VideooEditor_BlankProject_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/Blank%20Project.png'
const VideooEditor_ITV_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/ITV.png'
const VideooEditor_KANALD_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/KANAL%20D.png'
const VideooEditor_ShowTV_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/Show%20TV.png'
const VideooEditor_StarTV_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/Star%20TV.png'
const VideooEditor_TRT1_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/TRT%201.png'
const VideooEditor_TVGlobo_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/TV%20Globo.png'
const VideooEditor_TV8_Image = BASE_STATIC_STORAGE_URL + '/images/company/sampleprojectthumbnails/TV8.png'

const Template1UUID = "6d5937df-785c-4be9-9520-57aac4bc381c";
const Template2UUID = "4e5800fc-a552-4a03-ab94-e0cdccac6d16";
const Template3UUID = "a79b0cdf-c1de-4b07-ab6d-b55bde832060";
const Template4UUID = "7b315109-a415-4e51-83c4-869b1dc5226a";

const Template_StarTVUUID ="8b2ae90a-bbf4-4516-9811-a3a1d4587bfa";
const Template_ITVUUID ="58ee7150-3e05-4068-aecb-88cd56ef93a5";
const Template_ShowTVUUID ="75a82528-204a-41f3-8c72-a0d409a7a0f0";
const Template_BBCUUID ="a902859a-a4ed-4bbc-abe6-f64f415bf3b2";
const Template_KANALDUUID ="2be6aa55-912f-4434-9af3-dc14eaa3aab9";
const Template_TRT1UUID ="10b8c2c1-65b0-42fb-ae3a-6ab9a7b36a0f";
const Template_TVGLOBOUUID ="0ab325d5-03d1-44c4-adce-89cf9c7d180b";
const Template_ATVUUID ="49608af0-f6d9-4035-a420-ed3d3e392a23";
const Template_TV8UUID ="812a1cfe-5be7-40ec-b629-7b963b665e82";
const Template_BlankProjectUUID ="f92948bc-6a70-419d-b06e-6840e037b7bb";


export const Projects = () => {
  const theme = useTheme();
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [sortKey, setSortKey] = useState(1);
  const [toolbarStyle, SetToolbarStyle] = useState('grid');
  const ToolbarStyleChange = () => { SetToolbarStyle(toolbarStyle === 'grid' ? 'list' : 'grid'); }

  const [isLoading, setIsLoading] = useState(true);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [pretPageUrl, setPretPageUrl] = useState(null);
  const [projectsArr, setProjectsArr] = useState([]);
  const [sortedArr, setSortedArr] = useState([]);

  const [projectTab, setProjectTab] = useState('default');
  const didMountRef = useRef(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [workspaceType, setWorkspaceType] = useState('all')
  const [workSpacesList, setWorkSpacesList] = useState([])
  const [reloadeUrl, setReloadeUrl] = useState(BASE_BACKEND_URL + '/user/projects/?title=Project')

  useEffect(() => {
    getWorkSpaces()
  }, [])

  useEffect(() => {
    const alreadyVisited = sessionStorage.getItem('projectsVisited');

    const checkAndFetchProjects = async () => {

      if (!alreadyVisited) {
        let result = await getProjects(BASE_BACKEND_URL + '/user/projects/');
        if (result.data.results.length === 0 && projectTab !== "sample") {
          handleTabChange(null, "sample");
          return;
        }
        sessionStorage.setItem('projectsVisited', 'true');
      }

      if (workspaceType === 'all') {
        GetProjects(BASE_BACKEND_URL + '/user/projects/?title=Project', projectTab);
        setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=Project', projectTab);
      } else {
        GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + '?title=Project', projectTab);
        setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + '?title=Project', projectTab);
      }

      if(!didMountRef.current) {
        didMountRef.current = true;
        return;
      }
    };
    checkAndFetchProjects();
    
  }, [])

  useEffect(() => {
    if (workspaceType === 'all') {
      GetProjects(BASE_BACKEND_URL + '/user/projects/?title=Project');
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=Project');
    } else {
      GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + '?title=Project');
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + '?title=Project');
    }
    handleTabChange(null,"default");

  },[workspaceType])

  useEffect(() => {
    let tempArr = copyObject(projectsArr)

    tempArr.sort((a, b) => {
      let returnValue;
      if (sortKey === 1) returnValue = a.title - b.title
      else if (sortKey === 2) returnValue = (+ new Date(a.updated_at)) - (+ new Date(b.updated_at))
      else if (sortKey === 3) returnValue = (+ new Date(b.updated_at)) - (+ new Date(a.updated_at))
      return returnValue
    })

    setSortedArr(tempArr)
  }, [projectsArr, sortKey])

  const sampleProjects = [
      {
        id: 1,
        uuid: Template_BlankProjectUUID,
        project_thumbnail: VideooEditor_BlankProject_Image,
        title: "Blank Project",
        is_sample: true,
      },      
      {
        id: 2,
        uuid: Template1UUID,
        project_thumbnail: VideooEditor_AddMusic_Image,
        title: languageStrs.try_autosubtitles_in_english,
        is_sample: true,
      },
      {
        id: 3,
        uuid: Template2UUID,
        project_thumbnail: VideooEditor_AddText_Image,
        title: languageStrs.try_translations_in_turkish,
        is_sample: true,
      },
      {
        id: 4,
        uuid: Template3UUID,
        project_thumbnail: VideooEditor_AddStock_Image,
        title: languageStrs.try_subtitles_in_spanish,
        is_sample: true,
      },
      {
        id: 5,
        uuid: Template4UUID,
        project_thumbnail: VideooEditor_AddTransitions_Image,
        title: languageStrs.try_ai_video_summary,
        is_sample: true,
      },
      {
        id: 6,
        uuid: Template_ATVUUID,
        project_thumbnail: VideooEditor_ATV_Image,
        title: "ATV",
        is_sample: true,
      },
      {
        id: 7,
        uuid: Template_BBCUUID,
        project_thumbnail: VideooEditor_BBC_Image,
        title: "BBC",
        is_sample: true,
      },
      {
        id: 8,
        uuid: Template_ITVUUID,
        project_thumbnail: VideooEditor_ITV_Image,
        title: "ITV",
        is_sample: true,
      },
      {
        id: 9,
        uuid: Template_KANALDUUID,
        project_thumbnail: VideooEditor_KANALD_Image,
        title: "KANAL D",
        is_sample: true,
      },
      {
        id: 10,
        uuid: Template_ShowTVUUID,
        project_thumbnail: VideooEditor_ShowTV_Image,
        title: "Show TV",
        is_sample: true,
      },
      {
        id: 11,
        uuid: Template_StarTVUUID,
        project_thumbnail: VideooEditor_StarTV_Image,
        title: "Star TV",
        is_sample: true,
      },
      {
        id: 12,
        uuid: Template_TRT1UUID,
        project_thumbnail: VideooEditor_TRT1_Image,
        title: "TRT 1",
        is_sample: true,
      },     
      {
        id: 13,
        uuid: Template_TV8UUID,
        project_thumbnail: VideooEditor_TV8_Image,
        title: "TV8",
        is_sample: true,
      },
      {
        id: 14,
        uuid: Template_TVGLOBOUUID,
        project_thumbnail: VideooEditor_TVGlobo_Image,
        title: "TV Globo",
        is_sample: true,
      },      
    ];

  const getWorkSpaces = async () => {
    try {
      const result = await getWorkspacesList()

      if (result.state === 'success') {
        if (typeof result.data === 'object') {
          setWorkSpacesList(result.data)
        }
      }
    } catch (err) {
      console.log(err.message)
    }
  }

  const handleClickTemplateDuplicate = async (uuid) => {
    if (!uuid ) return
  
      let result = await duplicateTemplateProject(uuid)
      if (result.state !== 'success') {
        return
      }
  
      let data = result.data
  
      // Check if access was denied
      if (data['Code'] === "Access Denied") {
        console.error("Cannot create template project: Access Denied");
        return;
      }
  
      console.log("Duplicated Project uuid: ", data['Duplicated Project uuid'])
  
      let duplicateUUID = data['Duplicated Project uuid']
      window.location.href = `${EDIT_FRONTEND_URL}/${duplicateUUID}/`
    }

  const GetProjects = async (url, tabName) => {
    setIsLoading(true);
    let result = await getProjects(url);
    if (projectTab === tabName && result.state === 'success') {
      setProjectsArr(result.data.results);
      setNextPageUrl(result.data.next);
      setPretPageUrl(result.data.previous);
    }
    setIsLoading(false);
    setHasLoadedOnce(true);
  }

  const nextPage = () => { 
    GetProjects(nextPageUrl, projectTab);
    setReloadeUrl(nextPageUrl)
  }
  const prePage = () => {
    GetProjects(pretPageUrl, projectTab);
    setReloadeUrl(pretPageUrl)
  }

  const handleTabChange = (event, newValue) => {
    setProjectTab(newValue);
    if (newValue === 'default') getDefaultProjects();
    else if (newValue === 'reel') getReelProjects();
    else if (newValue === 'aiSummary') getAISummaryProjects();
    else if (newValue === 'all') getAllProjects();
    else if (newValue === 'sample') getSampleProjects();
  };

  const getAllProjects = () => {
    if(workspaceType !== 'all') {
      GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType, projectTab);
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType);
      return;
    }
    GetProjects(BASE_BACKEND_URL + '/user/projects/', projectTab);
    setReloadeUrl(BASE_BACKEND_URL + '/user/projects/');
  }

  const getDefaultProjects = () => {
    if(workspaceType !== 'all') {
      GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=Project", projectTab);
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=Project");
      return;
    }
    GetProjects(BASE_BACKEND_URL + '/user/projects/?title=Project', projectTab);
    setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=Project');
  } 

  const getReelProjects = () => {
    if(workspaceType !== 'all') {
      GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=Reel", projectTab);
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=Reel");
      return;
    }
    GetProjects(BASE_BACKEND_URL + '/user/projects/?title=Reel', projectTab);
    setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=Reel');
  } 

  const getAISummaryProjects = () => {
    if(workspaceType !== 'all') {
      GetProjects(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=AISummary", projectTab);
      setReloadeUrl(BASE_BACKEND_URL + '/user/projects/workspace/' + workspaceType + "?title=AISummary");
      return;
    }
    GetProjects(BASE_BACKEND_URL + '/user/projects/?title=AISummary', projectTab);
    setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=AISummary');
  } 

  const getSampleProjects = () => {
    setIsLoading(false);
    setSortedArr(sampleProjects)
    setProjectsArr(sampleProjects);
    setIsLoading(true);

    setReloadeUrl(BASE_BACKEND_URL + '/user/projects/?title=SampleProject');
  }

  const workspaceUUIDchange = async ({ target }) => {
    const uuid = target.value
    const checkUuid = workSpacesList.find((workspace) => (
      workspace.uuid === uuid
    ))

    if (checkUuid || uuid === 'all') {
      setWorkspaceType(uuid)
    }
  }

  const handleOnDelete = () => {
    GetProjects(reloadeUrl, projectTab);
  }

  return (
    <Box className="custom-projects-wrapper">
      <Box
        className="custom-projects-toolbar-section"
        sx={{
          borderBottom: "none !important"
        }}
      >
        <Box className="toolbar-Breadcrumbs-contain">
        <Tabs
          value={projectTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{
            sx: {
              backgroundColor: theme.palette.mode === 'light' ?  '#0d85a1' : '#17d3ff', 
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: theme.palette.mode === 'light'  ?  '#0d85a1' : '#17d3ff', 
            },
            '& .MuiTab-root': {
              color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#1b1c1c',
            },
          }}
        >
            <Tab label={languageStrs.projects} value="default" />
            <Tab label="AI Reels" value="reel" />
            <Tab label="AI Summaries" value="aiSummary" />
            <Tab label="Sample Projects" value="sample" />
            <Tab label="All" value="all" />
          </Tabs>
        </Box>
        <Box className="toolbar-layoutOption-section">
          {/* <Box className="sortby-wrapper">
            <span className="sortby-title">Sort By</span>

            <Select value={sortKey}
              className="toolbar-SortBy-select"
              onChange={(event) => { setSortKey(event.target.value); }}
            >
              <Box className="toolbar-SortBy-select-header">Sort By</Box>

              <MenuItem value={1} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Name</span>
              </MenuItem>

              <MenuItem value={2} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Date Created</span>
              </MenuItem>

              <MenuItem value={3} className="toolbar-SortBy-select-item">
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>Date Modified</span>
              </MenuItem>
            </Select>
          </Box> */}

          <div className="sortby-wrapper">
          <Select
            value={workspaceType || 'all'}
            className="toolbar-SortBy-select"
            onChange={workspaceUUIDchange}
            MenuProps={{
              PaperProps: {
                sx: {
                  "*": {
                    fontFamily: "Poppins, sans-serif !important",
                  },
                  "& .MuiMenuItem-root.Mui-selected": {
                    backgroundColor: "#17d3ff",
                  },
                  "& .MuiMenuItem-root.Mui-selected:hover": {
                    backgroundColor: "#0d85a1", 
                  },
                },
              },
            }}
            sx={{
              "*": {
                fontFamily: "Poppins, sans-serif !important",
              },
            }}
          >

              <Box className="toolbar-SortBy-select-header">{languageStrs.workspace}</Box>

              <MenuItem

              value='all' 
              className="toolbar-SortBy-select-item"
              sx={{
                "*": {
                  fontFamily: "Poppins, sans-serif !important"
                },
               }}
              >
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>{languageStrs.all_workspaces}</span>
              </MenuItem>

              {workSpacesList.map((workspace, key) => (
                <MenuItem 
                  key={key}
                  value={workspace.uuid}
                  className="toolbar-SortBy-select-item"
                  sx={{
                    "*": {
                      fontFamily: "Poppins, sans-serif !important"
                    }
                   }}
                >
                    <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                    <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                  <Tooltip title={workspace?.uuid} arrow placement="left">
                    <span>{workspace?.title}</span>
                  </Tooltip>
                </MenuItem>
              ))}
            </Select>
          </div>

          {/* <Box className="projects-toolbar-style-contain" onClick={ToolbarStyleChange}>
            {toolbarStyle === 'grid' ? (
              <Tooltip title="view as list"><FormatListBulletedOutlinedIcon /></Tooltip>
            ) : (
              <Tooltip title="view as grid"><WindowOutlinedIcon /></Tooltip>
            )}
          </Box> */}
        </Box>
      </Box >
      {
        projectTab == "sample" ? "" : (
      <Box className='projects-next-preview-btn' paddingBottom={1.5}>
          <Stack direction="row" spacing={2}>
            <Button onClick={prePage} variant="outlined" startIcon={<SkipPreviousIcon />} disabled={!!pretPageUrl ? false : true}>
              {languageStrs.previous}
            </Button>

            <Button onClick={nextPage} variant="outlined" endIcon={<SkipNextIcon />} disabled={!!nextPageUrl ? false : true}>
              {languageStrs.next}
            </Button>
          </Stack>
        </Box>
      )}

        <Box className="custom-projects-contents-section">

        {/* Only show NoContent if not loading, after first API response, and no projects */}
        {!isLoading && sortedArr.length === 0 && hasLoadedOnce && (
          <NoContent />
        )}

        {sortedArr.length !== 0 &&
          <>
          {toolbarStyle === 'grid' ? (
            <Box className="projects-container">
              <Grid container spacing={2}>
                {
                  projectTab == "sample" ? sampleProjects.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} lg={4} xl={2.4} key={index}>
                      <GridItem onDelete={handleOnDelete} itemData={item} onSampleEdit={handleClickTemplateDuplicate} />
                    </Grid>
                  )) :  sortedArr.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={2.4} key={index}>
                    <GridItem onDelete={handleOnDelete} itemData={item} />
                  </Grid>
                ))}
                
              </Grid>
            </Box>
          ) : (
            <Box className="list-projects-container">
              <Box className="projects-header-wrapper">
                <Box className="projects-header-NameTableCell1"></Box>
                <Box className="projects-header-NameTableCell1">{languageStrs.name}</Box>
                <Box className="projects-header-NameTableCell2">{languageStrs.status}</Box>
                <Box className="projects-header-NameTableCell3">{languageStrs.data_modified}</Box>
                <Box className="projects-header-NameTableCell4"></Box>
              </Box>

              {sortedArr.map((item) => (
                <ListItem onDelete={handleOnDelete} itemData={item} key={item.uuid} />
              ))}
            </Box>
          )}
          </>
        }

        </Box>


        {/* Only show spinner if loading */}
        {isLoading && (
          <Box className='absolute top-1/2 left-1/2 -translate-x-1/2'>
            <ReactLoading type={'spinningBubbles'} color='rgb(53 126 221)' height={100} width={100} />
          </Box>
        )}
      
    </Box >
  )
}